

















































































import { Component, Vue, Emit } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ExerciseList from "@/components/cards/word/ExerciseList.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import SingleDayWord from "@/components/cards/SingleDayWord.vue";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import Spiner from "@/components/englishjanala/Spiner.vue";
import * as data from "@/model/englishjanala/englishjanala.json";
import NewLevel from "@/components/modals/words/NewLevel.vue";
import axios from "axios";
import NewWord from "@/components/modals/NewWord.vue";
import EditWord from "@/components/modals/words/EditDayWord.vue";

import { Dialog, Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    NewLevel,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
    SingleDayWord,
    ExerciseList,
    NewWord,
    Spiner,
    EditWord,
  },
})
export default class WordLevel extends Vue {
  WordId: any;
  chap: any;
  categoryName: any;
  wordLevels: any = null;
  levelId: number = -1;
  dayOfTheWords = "";
  currentIndex = -1;
  Spiner: boolean = true;
  day: any = "";
  show: boolean = false;
  show1: boolean = false;
  Editable: boolean = false;
  async mounted() {
    const CatId = { request_payload: 10 };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetMonthlyWordsOfTheDay",
      CatId
    );
    // const data = response.data.levels;
    // this.wordLevels = data;
    // console.log(data);
    this.dayOfTheWords = response.data.monthlyWordsOfTheDay.dailyWordsOfTheDay;
    this.Spiner = false;
  }
  MouseHover(levelId: any) {
    this.levelId = levelId;
  }
  get today() {
    return new Date().getDate();
  }
  MouseLeave(levelId: any) {
    this.levelId = -1;
  }
  DeleteWordLevel(id: any, index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        const PassData = { category_id: this.CategoryId, level_id: id };
        const response = axios
          .post(
            "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/DeleteWordLevel",
            PassData
          )
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Word Level is not deleted" });
          });
        this.$delete(this.wordLevels, index);
        Notify({ type: "success", message: "Word Level deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }
  get CategoryId() {
    this.WordId = this.$route.params.CategoryId;
    return this.$route.params.CategoryId;
  }
  get Words() {
    return data.wordCategories.filter((item) => {
      return item.id == this.WordId;
    });
  }

  getImgUrl(item: any) {
    return item.imageUrl;
  }
  created() {
    this.WordId = this.$route.params.CategoryId;
    this.categoryName = this.$route.params.Category;
  }
  get currentRouteName() {
    return this.$route.name;
  }
  showModal(day: any) {
    this.day = day;
    // alert(this.day);
    this.show = false;
    this.show = true;
    this.show1 = false;
  }
  showEditModal(day: any, index: any) {
    this.day = day;
    this.Editable = true;
    this.currentIndex = index;
    // alert(this.day);
    this.show1 = false;
    this.show1 = true;
    this.show = false;
  }
  UpdateDayWord(words: any) {
    this.show = false;
    const data = {
      words_of_the_day: {
        day: this.day,
        words: words,
      },
    };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/PutWordsOfTheDay",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added in days" });
      });
    Notify({ type: "success", message: "Word is added in days" });
  }
  ShowPopup(word: any, index: any) {
    alert(index);
    this.currentIndex = index;
    this.show1 = true;
  }
  ModalClose() {
    this.show1 = false;
    this.show = false;
  }
}
